import { render, staticRenderFns } from "./audio-upload-release.vue?vue&type=template&id=0f6e8f2a&"
import script from "./audio-upload-release.vue?vue&type=script&lang=js&"
export * from "./audio-upload-release.vue?vue&type=script&lang=js&"
import style0 from "./audio-upload-release.vue?vue&type=style&index=0&id=0f6e8f2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports